export const isTicketMuted = ticket => {
  if (!ticket?.isMuted) return false;
  if (!ticket.mutedUntil) return true;

  return new Date(ticket.mutedUntil).getTime() > Date.now();
};
